import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <div className="pt-12 pb-8 px-4 max-w-4xl mx-auto text-center" data-id="element-157">
      <div className="inline-block bg-white border border-brand-border rounded-full px-4 py-1.5 font-semibold text-brand-title mb-4 text-[12px] tracking-[0.15em] uppercase shadow-sm" data-id="element-158">
        💃 INSTRUCTORAS DE ZUMBA EN ESPAÑA
      </div>

      <h1 className="font-display text-brand-title md:text-6xl font-bold tracking-tight mb-6 text-[32px] leading-tight" data-id="element-159">
        Deja de improvisar cada semana.
        <br data-id="element-160" />
        Empieza a cobrar lo que mereces.
      </h1>

      <div className="my-6 flex justify-center" data-id="element-161">
        <img src="https://cdn.magicpatterns.com/uploads/db55hm39pPvsCQxNyf8uNx/zumba_mockup_webp_sin_fondo.webp" alt="El Manual del Instructor de Zumba — 6 Tomos + 6 Bonos" width="800" height="800" fetchPriority="high" loading="eager" decoding="sync" className="w-full max-w-2xl" data-id="element-162" />
      </div>

      <p className="text-xl md:text-2xl text-brand-text font-semibold mb-6 tracking-wide font-body" data-id="element-163">
        El Manual de Zumba más completo de España. 6 Tomos + 6 Bonos. Descarga
        inmediata. Listo para usar hoy.
      </p>

      <div className="flex items-center justify-center gap-2 mb-6 text-sm flex-wrap" data-id="element-164">
        <div className="flex text-brand-title" data-id="element-165">⭐⭐⭐⭐⭐</div>
        <span className="text-brand-text font-medium" data-id="element-166">4.9/5</span>
        <span className="text-brand-textMuted" data-id="element-167">·</span>
        <span className="text-brand-text font-medium" data-id="element-168">
          🔥 +400 instructoras en España
        </span>
        <span className="text-brand-textMuted" data-id="element-169">·</span>
        <span className="text-brand-text font-medium" data-id="element-170">
          ⚡ Acceso en 2 minutos
        </span>
      </div>

      <button onClick={scrollToPricing} className="bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-xl md:text-2xl py-4 px-8 rounded-2xl transition-colors w-full md:w-auto mb-4 tracking-wide shadow-gold-glow" data-id="element-171">
        🚀 QUIERO MI MANUAL AHORA
      </button>
    </div>;
}